import React, {Component, PropTypes} from 'react'
import {FormControl, Radio, Overlay, Popover} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import {convertYearToJalali, convertYearToGregorian, applyLimitation} from '../../../utils/dateHelper'

class Datepicker extends Component {
  constructor (props) {
    super(props)
    this.state = {
      mongosValue: props.gregorian ? props.gregorian + '' : '',
      isMongosJalaali: false,
      showOverlay: false,
      year: props.gregorian ? props.gregorian : '',
      jalaali: props.jalaali ? props.jalaali : (props.gregorian ? convertYearToJalali(props.gregorian) : ''),
      touched: [],
      errors: {}
    }

    this.checkAndSaveDates = this.checkAndSaveDates.bind(this)
    this.radioClick = this.radioClick.bind(this)
    this.persistValues = this.persistValues.bind(this)
    this.toggleOverlay = this.toggleOverlay.bind(this)
    this.validate = this.validate.bind(this)
  }

  componentWillMount () {
    const {gregorianValue, jalaaliValue, errors, touched} = this.props
    this.setState({errors: errors, touched: touched})

    if (gregorianValue) {
      this.setState({mongosValue: jalaaliValue})
      this.persistValues(gregorianValue)
      this.toggleOverlay(false)
    }
  }

  isMongosJalaali (date) {
    return date <= convertYearToJalali(new Date().getFullYear())
  }

  toggleOverlay (show = !this.state.showOverlay) {
    if (show && (this.state.mongosValue.length !== 4)) {
      return undefined
    }

    this.setState({showOverlay: show})
  }

  radioClick (e) {
    const {isMongosJalaali} = this.state
    const {gregorianFieldName, jalaaliFieldName} = this.props

    let o = {}
    o[isMongosJalaali ? gregorianFieldName : jalaaliFieldName] = parseInt(e.target.value, 10)
    Actions.setNewHorseDetails(o)
    this.setState({showOverlay: false})
  }

  checkAndSaveDates (e) {
    if (e.target.value.length > 4) { return undefined }
    let value = e.target.value
    value = applyLimitation(value, 1300, convertYearToJalali(new Date().getFullYear()), 1900, new Date().getFullYear())
    this.setState({mongosValue: value, showOverlay: false})
    this.persistValues(value)
  }

  persistValues (value) {
    const valueString = value + ''
    if (valueString.length === 0) {
      let o = {}
      o[this.props.jalaaliFieldName] = undefined
      o[this.props.gregorianFieldName] = undefined
      return Actions.setNewHorseDetails(o)
    }
    if (valueString.length !== 4) { return undefined }

    const {gregorianFieldName, jalaaliFieldName} = this.props
    const isJalaali = this.isMongosJalaali(value)
    this.setState({
      showOverlay: true,
      isMongosJalaali: isJalaali,
      jalaali: isJalaali ? value : convertYearToJalali(value),
      year: isJalaali ? convertYearToGregorian(value) : value
    })
    let o = {}
    o[jalaaliFieldName] = isJalaali ? parseInt(value, 10) : convertYearToJalali(value)
    o[gregorianFieldName] = isJalaali ? convertYearToGregorian(value) : parseInt(value, 10)
    Actions.setNewHorseDetails(o)
  }

  validate (e) {
    Actions.addNewHorseTouched(this.props.gregorianFieldName)
    Actions.addNewHorseTouched(this.props.jalaaliFieldName)
    Actions.validateNewHorseData()
  }

  render () {
    const {placeholder, gregorianFieldName, jalaaliValue, gregorianValue, touched, errors} = this.props
    const {mongosValue, isMongosJalaali, year, jalaali, showOverlay} = this.state

    const hasError = () => {
      if (touched && errors) {
        return (touched.indexOf(gregorianFieldName) !== -1) && errors[gregorianFieldName]
      }
      return false
    }

    const jalaaliPopover = (<Popover id="popover-jalaali">
      <h7>معادل</h7>
      <Radio name="year" value={year} onClick={this.radioClick} inline defaultChecked={year === parseInt(gregorianValue, 10)}>
        {year}
      </Radio>
      {' '}
      <Radio name="year" value={year + 1} onClick={this.radioClick} inline defaultChecked={(year + 1) === parseInt(gregorianValue, 10)}>
        {year + 1}
      </Radio>
    </Popover>)

    const gregorianPopover = (<Popover id="popover-gregorian" >
      <h7>معادل</h7>
      <Radio name="converted" value={jalaali} onClick={this.radioClick} inline defaultChecked={jalaali === parseInt(jalaaliValue, 10)}>
        {jalaali}
      </Radio>
      {' '}
      <Radio name="converted" value={jalaali + 1} onClick={this.radioClick} inline defaultChecked={(jalaali + 1) === parseInt(jalaaliValue, 10)} >
        {jalaali + 1}
      </Radio>
    </Popover>)

    return (
      <div>
        <FormControl
          id={`mongos_${gregorianFieldName}`}
          type="number"
          name={`mongos_${gregorianFieldName}`}
          placeholder={placeholder}
          className={`form-control ${hasError() ? 'form-component-error' : ''}`}
          onChange={this.checkAndSaveDates}
          value={mongosValue}
          onBlur={this.validate}
          onClick={() => this.toggleOverlay()}
        />
        <Overlay show={showOverlay} onHide={() => this.toggleOverlay(false)} container={this} rootClose placement="bottom" target={document.getElementById(`mongos_${gregorianFieldName}`)}>
          {isMongosJalaali ? jalaaliPopover : gregorianPopover}
        </Overlay>
      </div>
    )
  }
}

Datepicker.propTypes = {
  gregorianFieldName: PropTypes.string.isRequired,
  jalaaliFieldName: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  gregorianValue: PropTypes.number,
  jalaaliValue: PropTypes.number,
  errors: PropTypes.object,
  touched: PropTypes.array
}

export default Datepicker



// WEBPACK FOOTER //
// ./src/components/NewHorse/Datepicker/Datepicker.js